import { render } from "./TacheButton.ts.vue?vue&type=template&id=01fca1a0&ts=true"
import script from "./TacheButton.ts.vue?vue&type=script&lang=ts"
export * from "./TacheButton.ts.vue?vue&type=script&lang=ts"

import "./TacheButton.ts.vue?vue&type=style&index=0&id=01fca1a0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__